import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth0 } from "../react-auth0-spa";

import { API_URL } from "../../constants/constants";

export const usePatchpaquetes = () => {
  // console.log(initialUser);
  // const [user, setUser] = useState();
  const [body, setBody] = useState({});
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { getTokenSilently, user } = useAuth0();

  useEffect(() => {
    // console.log(body);

    if (Object.keys(body).length === 0) return;
    const fetchDirecciones = async () => {
      setIsError(false);
      setIsLoading(true);
      try {
        const { nombre, alto, ancho, largo, contenido, _id, peso } = body;
        // console.log(alto, ancho, largo);

        const t = await getTokenSilently();
        const r = await axios.patch(
          API_URL + `/paquetes/${user.sub}`,
          {
            nombre,
            alto: Number(alto),
            ancho: Number(ancho),
            largo: Number(largo),
            peso: Number(peso),
            contenido,
            _id
          },
          {
            headers: {
              // "Access-Control-Allow-Origin": "*",
              Authorization: `Bearer ${t}`
            }
          }
        );
        setData(r.data);
        // console.log(r.data);
      } catch (error) {
        console.log(error);
        setIsError(true);
      }
      setIsLoading(false);
    };
    fetchDirecciones();
  }, [body,getTokenSilently,user.sub]);

  return [{ data, isLoading, isError }, setBody];
};

export default usePatchpaquetes;
